module.exports = __webpack_public_path__ + "img/logo_min.a9eba0e9.png";